// import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";
// import withCheckPermissions from "@/layouts/GeneralLayoutWrapper/withCheckPermissions";
import Transactions from "@/pages/Transactions";

// export const ProtectedPaymentHistory = withCheckPermissions(Transactions, PagesAccess.COUNTRY, OperationAccess.LIST);
export const ProtectedTransactions = Transactions;
